export default __webpack_public_path__ + "static/media/hero@3x.539f661b.png";